import { constants } from '@clubmed/utils';
const { WINTER_MOUNTAIN_RESORT } = constants;
export function isWinterResort({ seasons = [], type = '' }: Product): boolean {
  return seasons.length === 1 && seasons.includes('WINTER') && type.toUpperCase() === 'VILLAGE';
}
export function isWinterMountainResort(product: { readonly category: string }): boolean {
  return product.category === WINTER_MOUNTAIN_RESORT;
}
export const resortHasBeActivities = (product: Product) =>
  product.activityCategories.leisure.some(({ subCategories }) => subCategories.length !== 0);
